const colors = [
  'rgba(78, 170, 241, 1)', // blue
  'rgba(255, 175, 9, 1)', // yel
  'rgba(40, 194, 112, 1)', // green
  'rgba(253, 93, 161, 1)', // pink
  'rgba(118, 105, 191, 1)', // purple
  'rgba(156, 162, 174, 1)', // grey
  'rgba(79, 151, 241, 1)', // blue 2
  'rgba(255, 199, 0, 1)', // yel 2
  'rgba(40, 194, 129, 1)', // green 2
  'rgba(253, 93, 142, 1)', // pink 2
  'rgba(127, 105, 191, 1)', // purple 2
  'rgba(156, 165, 174, 1)', // grey 2
  'rgba(77, 183, 240, 1)', // blue 3
  'rgba(255, 156, 16, 1)', // orange
  'rgba(40, 194, 99, 1)', // green 3
  'rgba(253, 92, 173, 1)', // pink 3
  'rgba(110, 105, 191, 1)', // purple 3
  'rgba(162, 155, 175, 1)', // grey purple
  'rgba(116, 76, 242, 1)', // purple 4
  'rgba(154, 240, 37, 1)', // neon green
  'rgba(43, 158, 195, 1)', // sky
  'rgba(253, 152, 89, 1)', // light orange
  'rgba(182, 105, 191, 1)', // weird purple
  'rgba(155, 170, 174, 1)', // grey blue
  'rgba(74, 225, 239, 1)', // fresh blue
  'rgba(255, 100, 28, 1)', // fresh orange
]

const darkColors = [
  'rgba(153, 187, 239, 1)', // light blue
  'rgba(77, 183, 240, 1)', // blue
  'rgba(78, 170, 241, 1)', // blue 2
  'rgba(79, 151, 241, 1)', // blue 3
  'rgba(40, 194, 99, 1)', // green
  'rgba(154, 240, 37, 1)', // noen green
  'rgba(181, 178, 159, 1)', // gray
  'rgba(255, 199, 0, 1)', // yellow
  'rgba(255, 175, 9, 1)', // yellow 2
  'rgba(255, 156, 16, 1)', // orange
  'rgba(253, 152, 89, 1)', // light orange
  'rgba(255, 100, 28, 1)', // orange 2
  'rgba(253, 93, 142, 1)', // pink
  'rgba(253, 92, 173, 1)', // pink 2
  'rgba(206, 129, 215, 1)', // light purple
  'rgba(159, 144, 240, 1)', // purple
  'rgba(180, 142, 228, 1)', // purple 2
  'rgba(170, 148, 234, 1)', // purple 3
  'rgba(185, 145, 255, 1)', // purple 4
  'rgba(57, 184, 189, 1)', // teal
  'rgba(90, 205, 242, 1)', // light teal
  'rgba(74, 225, 239, 1)', // fresh blue
  'rgba(155, 170, 174, 1)', // grey 2
  'rgba(156, 162, 174, 1)', // grey 3
  'rgba(161, 167, 177, 1)', // grey blue
  'rgba(156, 165, 174, 1)', // grey 4
  'rgba(180, 151, 175, 1)', // purple grey
  'rgba(162, 155, 171, 1)', // grey purple
]

function getRandomColor(id, index) {
  if (!id && (index === null || index === undefined)) return 0
  if (id) {
    return colors[id % colors.length]
  }
  return colors[index]
}

function getAudienceColor(audienceId, isLightMode = true) {
  const number = parseInt(audienceId.slice(0, 5), 16) // audienceId is in uuid-v4 (hex) format
  const index = parseInt(number % (colors.length - 1), 10)

  if (isLightMode) {
    return colors[index]
  }
  return darkColors[index]
}

export default {
  colors,
  getRandomColor,
  getAudienceColor,
}
